import React from 'react';
import { programs } from '../../data/programs';
import { site, socials } from '../../data/site';
import { Container } from '../ui/Container';
import { SocialIcon } from '../ui/SocialIcon';
import { programPaths, schoolLinks } from '../../data/navigation';
const headingClass = 'text-sm font-semibold uppercase tracking-[0.12em] text-white/55';
const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-white/80 transition-colors duration-150 hover:text-white';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-black text-white" data-id="element-341" data-mp="3s0u7g9b5o5pb">
      <Container className="grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8" data-id="element-342" data-mp="3n4lvt5w62umw">
        <div className="sm:col-span-2 lg:col-span-4" data-id="element-343" data-mp="3j2s0ld4qqiu4">
          <a href="/" className="inline-flex items-center gap-4" data-id="element-344" data-mp="3j05s9ba0zzau">
            <img src={site.logo} alt="" className="h-24 w-auto" loading="lazy" data-id="element-345" data-mp="3e1kurjm5rtq3" />
            <span className="font-display text-[1.75rem] font-bold uppercase leading-[0.95] tracking-wide" data-id="element-346" data-mp="394ucqqqsmo21">
              Bates
              <br data-id="element-347" data-mp="2kbtjkvgh2clq" />
              Taekwondo
            </span>
          </a>
          <p className="mt-5 max-w-[22rem] text-[15px] leading-relaxed text-white/70" data-id="element-348" data-mp="2p4uzn6sf0i6w">
            Family-owned and operated since 2015. Olympic-style Taekwondo for ages 3 through adult in Albuquerque.
          </p>
        </div>

        <div className="lg:col-span-3" data-id="element-349" data-mp="2gbrjgqqdxr8k">
          <h2 className={headingClass} data-id="element-350" data-mp="340kg6peu0348">Visit &amp; contact</h2>
          <address className="mt-4 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-351" data-mp="33yzjou8yia3q">
            {site.street}
            <br data-id="element-352" data-mp="2u2wlfzh86vm2" />
            {site.cityLine}
          </address>
          <ul className="mt-2" data-id="element-353" data-mp="2u2eikk025j56">
            <li data-id="element-354" data-mp="2z20tgmseynat">
              <a href={site.directionsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-355" data-mp="2z1hlnywh9fai">
                Get directions<span className="sr-only" data-id="element-356" data-mp="1impqxfbuzvy1"> (opens in a new tab)</span>
              </a>
            </li>
            <li data-id="element-357" data-mp="1nnvp3soagbey">
              <a href={site.phoneHref} className={linkClass} data-id="element-358" data-mp="1nof2cw2zubmn">
                {site.phoneDisplay}
              </a>
            </li>
            <li data-id="element-359" data-mp="zj4g1pm113mt">
              <a href={site.emailHref} className={linkClass} data-id="element-360" data-mp="zimag2dh5d28">
                {site.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2" data-id="element-361" data-mp="uql40x2zmgk4">
          <h2 className={headingClass} data-id="element-362" data-mp="ptkto9z3urn7">Programs</h2>
          <ul className="mt-3" data-id="element-363" data-mp="pst8zu71qebp">
            {programs.map(p => <li key={p.id} data-id="element-364" data-mp="kvb023t13z3p">
                <a href={programPaths[p.id]} className={linkClass} data-id="element-365" data-mp="kvjcxvp5j4ew">
                  {p.name}
                </a>
              </li>)}
            <li data-id="element-366" data-mp="bt1qbg5l49rd">
              <a href="/free-trial-class" className={linkClass} data-id="element-367" data-mp="bss29y43ocob">
                Free trial class
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3" data-id="element-368" data-mp="267kt7ju1gf9x">
          <h2 className={headingClass} data-id="element-369" data-mp="266jglaxdjkq3">School information</h2>
          <ul className="mt-3" data-id="element-370" data-mp="218hxwr3v1nf5">
            {[{
            label: 'Class schedule',
            href: '/schedule'
          }, {
            label: 'Our coaches',
            href: '/instructors'
          }, ...schoolLinks].map(link => <li key={link.href} data-id="element-371" data-mp="28rhhoxv8hgz1"><a href={link.href} className={linkClass} data-id="element-372" data-mp="28pwmr750bw0n">{link.label}</a></li>)}
          </ul>
          <h2 className={`${headingClass} mt-7`} data-id="element-373" data-mp="2dp997qryv12p">Follow Bates</h2>
          <ul className="mt-3" data-id="element-374" data-mp="2iivaynwldkjq">
            {socials.map(s => <li key={s.name} data-id="element-375" data-mp="2ngne6e2ost38">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-376" data-mp="2nfviz4d04xdh">
                  <SocialIcon name={s.name} className="h-[18px] w-[18px]" data-id="element-377" data-mp="1pug8f0uncupa" />
                  {s.label}
                  <span className="sr-only" data-id="element-378" data-mp="1usrk7h4i5fa5"> (opens in a new tab)</span>
                </a>
              </li>)}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10" data-id="element-379" data-mp="23tfpnnfty7bf">
        <Container className="flex flex-col gap-2 py-6 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-380" data-mp="23u8ugiv8amqx">
          <p data-id="element-381" data-mp="3b8u4owlqe5uq">© {year} Bates Taekwondo. All rights reserved.</p>
          <p data-id="element-382" data-mp="3f6rthyblapxl">
            {site.street}, {site.cityLine}
          </p>
        </Container>
      </div>
    </footer>;
}